import { vars } from '@etg/wings';
import { css, cx } from '@eti/styles';
import { UI } from 'react-day-picker';

export const calendarStyles = {
  [UI.Root]: 'rdp-root',
  [UI.CaptionLabel]: css`
    align-self: center;
    color: ${vars.colors.text.primary};
    flex: 1;
    font-size: 0.875rem;
    font-weight: 500;
    text-align: center;
  `,
  [UI.Nav]: css`
    display: flex;
    justify-content: space-between;
    position: absolute;
    width: 100%;
  `,
  [UI.MonthGrid]: css`
    border-collapse: separate;
    border-spacing: 0.25rem;
    margin-top: 0.5rem;
    width: 100%;
  `,
  [UI.Months]: css`
    width: 100%;
  `,
  [UI.Weekday]: css`
    font-weight: 400;
    padding-bottom: 0.25rem;
    text-transform: unset;
  `,
  [UI.Day]: cx('notranslate', 'rdp-day'),
  [UI.DayButton]: css`
    appearance: none;
    background-color: transparent;
    border: none;
    border-radius: 0.1875rem;
    font-size: 0.875rem;
    height: 100%;
    position: relative;
    -webkit-tap-highlight-color: transparent;
    width: 100%;

    .rdp-selected && {
      background-color: ${vars.colors.inputs.main};
      color: ${vars.colors.text.inverse};
    }

    .rdp-masked &&,
    .rdp-in-range && {
      background-color: ${vars.colors.inputs.selected};
    }

    &:hover {
      background-color: ${vars.colors.inputs.hover};
      cursor: pointer;
    }

    &[disabled] {
      color: ${vars.colors.text.secondary};
      cursor: auto;
      opacity: 1;
    }

    &[disabled]:hover {
      background-color: unset;
    }

    &:focus-visible {
      background-color: ${vars.colors.inputs.hover};
      outline: 0.125rem solid ${vars.colors.focusRing};
      outline-offset: 0.0625rem;
    }
  `,
};
